// extracted by mini-css-extract-plugin
export default {"hub_wrapper":"Wv","title":"Xv","hub":"Yv","hub_cards":"Zv"};
    if(module.hot) {
      // 1715276855807
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  